'use client'
import { FC } from 'react'
import { useAppConfigContext } from '#/src/appConfig'
import { MenuStandardSlideOutMobileMenuFooter } from 'storefront-modules/layout/Menu/MenuStandard'

interface IMobileMenuSlideOutFooterProps {}

const MobileMenuSlideOutFooter: FC<IMobileMenuSlideOutFooterProps> = () => {
  const appConfig = useAppConfigContext()

  return <MenuStandardSlideOutMobileMenuFooter panelItems={appConfig.topNavPanel?.items} />
}

export default MobileMenuSlideOutFooter
